import { Icons } from '@agro-club/agroclub-shared'
import { useTranslation } from 'react-i18next'
import { AButton } from 'views/components/Analytics'
import { Pagination } from 'views/components/Pagination/Pagination'
import { ListFooterWrapper } from 'views/styled/common'
import { TaskManagerReturnType } from '../useUserTasksManager'

type Props = {
  openTaskModal: (boolean?) => void
  taskManager: TaskManagerReturnType
}

export const TaskBlockFooter = ({ openTaskModal, taskManager }: Props) => {
  const { total, listRequestParams, setListRequestParams } = taskManager
  const { t } = useTranslation('task')

  return (
    <ListFooterWrapper>
      <AButton id="add_task" color="approve" Icon={Icons.IconAdd} onClick={openTaskModal}>
        {t('common:add')}
      </AButton>
      <Pagination
        disableMargin
        total={total}
        currPage={listRequestParams.page}
        setCurrPage={(page) => setListRequestParams((prev) => ({ ...prev, page }))}
      />
    </ListFooterWrapper>
  )
}
